import { Controller } from "@hotwired/stimulus";

// Toggles mic/camera on the active LiveKit room connection.
// Used for mobile inline controls next to the presence badge.
// Works by finding the LiveKitRoom's LocalParticipant via the global room reference.
export default class extends Controller {
  static targets = ["micBtn", "camBtn"];
  static values = {
    micLabel: { type: String, default: "Mute" },
    camLabel: { type: String, default: "Camera off" },
  };

  toggleMic() {
    const room = this.#findRoom();
    if (!room?.localParticipant) return;

    const participant = room.localParticipant;
    const enabled = participant.isMicrophoneEnabled;
    participant.setMicrophoneEnabled(!enabled);

    if (this.hasMicBtnTarget) {
      this.micBtnTarget.classList.toggle("text-error", enabled);
      this.micBtnTarget.classList.toggle("text-content-muted", !enabled);
    }
  }

  toggleCam() {
    const room = this.#findRoom();
    if (!room?.localParticipant) return;

    const participant = room.localParticipant;
    const enabled = participant.isCameraEnabled;
    participant.setCameraEnabled(!enabled);

    if (this.hasCamBtnTarget) {
      this.camBtnTarget.classList.toggle("text-error", enabled);
      this.camBtnTarget.classList.toggle("text-content-muted", !enabled);
    }
  }

  // LiveKit stores the room instance on the connected element.
  // The turbo-mount VideoPanel renders inside a div with data-controller="turbo-mount-video-panel".
  // We access the room via the LiveKitRoom context exposed on window by our VideoPanel.
  #findRoom() {
    return window.__livekitRoom;
  }
}
